<template>
    <a-modal :visible="isShow" width="960px" title="修改收件人信息" :footer="null" @cancel="cancel" class="address_modal">
        <a-form-model :model="receiveForm" ref="receiveForm" :rules="rules" labelAlign="left" class="underline_input_form">
            <a-form-model-item label="收货人姓名" prop="name">
                <a-input v-model="receiveForm.name" />
            </a-form-model-item>
            <a-form-model-item label="所在地区" prop="region">
                <select-address :region="receiveForm.region" ref="region" @change="changeAreaInfo" />
            </a-form-model-item>
            <a-form-model-item label="手机号码" prop="mobile">
                <a-input v-model="receiveForm.mobile" />
            </a-form-model-item>
            <a-form-model-item label="详细地址" prop="address">
                <a-input v-model="receiveForm.address" />
            </a-form-model-item>
        </a-form-model>
        <smart-address-textarea @ok="recognizeAddress" class="mt20" />
        <div class="btn_confirm">
            <a-button type="primary" @click="ok">保存</a-button>
        </div>
    </a-modal>
</template>

<script>
import SelectAddress from '@/components/common/address/SelectAddress'
import SmartAddressTextarea from '@/components/common/address/SmartAddressTextarea'

export default {
    name: 'EditAddressModal',
    components: { SelectAddress, SmartAddressTextarea },
    model: {
        prop: 'isShow',
        event: 'hidden'
    },
    props: {
        isShow: {
            type: Boolean,
        },
        editItem: {
            type: Object,
            required: false
        }
    },
    data () {
        return {
            receiveForm: {
                id: '',
                name: '',
                mobile: '',
                address: '',
                region: {
                    province_id: 0,
                    city_id: 0,
                    district_id: 0,
                    town_id: 0
                },
                area_info: ''
            },
            rules: {
                name: [
                    { required: true, message: '请输入收货人姓名', trigger: ['blur','change'] },
                ],
                mobile: [
                    { required: true, message: '请输入手机号码', trigger: ['blur','change'] },
                    // { validator: this.$validate.mobile, trigger: ['blur','change'] }
                ],
                address: [
                    { required: true, message: '请输入详细地址', trigger: ['blur','change'] },
                ],
                region: [
                    { required: true, message: '请选择所在地区', trigger: ['blur','change'] },
                ]
            }
        }
    },
    created () {
    },
    methods: {
        ok () {
            let _validate = true
            this.$refs.receiveForm.validate(valid => {
                if (!valid) _validate = false
            })
            this.$refs.region.validate(valid => {
                if (!valid) _validate = false
            })

            if (!_validate) return

            var _this = this;

            _this.$util.api('/address/receive/submit',{
                id: _this.receiveForm.id,
                tname: _this.receiveForm.name,
                mob_phone: _this.receiveForm.mobile,
                province_id: _this.receiveForm.region.province_id,
                city_id: _this.receiveForm.region.city_id,
                district_id: _this.receiveForm.region.district_id,
                street_id: _this.receiveForm.region.town_id,
                address: _this.receiveForm.address,
            },function(res){
                _this.$message[res.code == 10000 ? 'success' : 'error'](res.msg);

                if(res.code == 10000){
                    _this.$emit('ok')
                    _this.cancel()
                }
            });
        },
        cancel () {
            this.$emit('hidden', false)
        },
        changeAreaInfo (data) {
            var area_info = data.province_name + data.city_name + data.district_name + data.town_name;
            
            this.receiveForm.region.province_id = data.province_id;
            this.receiveForm.region.city_id = data.city_id;
            this.receiveForm.region.district_id = data.district_id;
            this.receiveForm.region.town_id = data.town_id;
            this.receiveForm.area_info = area_info;
        },
        resetValidate () {
            const _props = ['name', 'mobile', 'address']
            this.$refs.receiveForm.clearValidate(_props)
            this.$refs.region.clearValidate()
        },
        recognizeAddress (data) {
            this.resetValidate()
            this.receiveForm = {
                name: data.name,
                mobile: data.mobile,
                region: {
                    province_id: data.province.id == null ? 0 : data.province.id,
                    city_id: data.city.id == null ? 0 : data.city.id,
                    district_id: data.district.id == null ? 0 : data.district.id,
                    town_id: data.town.id == null ? 0 : data.town.id,
                },
                address: data.address
            }
        },

    },
    watch: {
        editItem: {
            handler (data) {
                this.$util.api('/address/receive/info',{
                    id: data.id
                },res => {
                    if(res.code == 10000){
                        this.receiveForm = {
                            id: data.id,
                            name: res.data.tname,
                            mobile: res.data.mob_phone == '' ? res.data.tel_phone : res.data.mob_phone,
                            address: res.data.address,
                            region: {
                                province_id: res.data.province_id,
                                city_id: res.data.city_id,
                                district_id: res.data.district_id,
                                town_id: res.data.street_id
                            },
                            area_info: ''
                        }
                    }
                });
            },
            deep: true,
            immediate: true
        }
    }
}
</script>

<style scoped>
.address_modal >>> .ant-modal-header {
    border-top: 5px solid #fd5902;
    text-align: center;
}
.address_modal >>> .ant-form-item:nth-child(n + 2) {
    margin-bottom: 0;
    margin-top: 35px;
}
.btn_confirm {
    text-align: center;
    margin-top: 20px;
}
.btn_confirm >>> .ant-btn {
    height: 34px;
    padding: 0 22px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/address/EditAddressModal.vue